/* eslint-disable */
import { Box, Card, Chip, styled, Typography } from "@mui/material";
import BackButton from "../BackButton/BackButton";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { useNavigate } from "react-router-dom";

const CardWrapper = styled(Card)(({ theme }) => ({
  padding: "16px 16px 16px 16px",
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "none !important",
  "& .ContentWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    marginBottom: "15px",
    "@media screen and (max-width:600px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
    "& h2": {
      fontSize: "24px",
      fontWeight: 700,
    },
  },
  "& .FilterChipWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    gap: "12px",
    "@media screen and (max-width:600px)": {
      justifyContent: "center",
    },
    "& .MuiChip-root": {
      "& svg": { color: "#E83D62" },
    },
  },
}));

function KanbanBoardHeader({ selectedPriority, getPriorityFilteredFlags, selectedFlags, searchParams, setSearchParams }) {
  const navigate = useNavigate();
  const handleBackClick = () => { // custom back button handler
    if (typeof onClick === "function") {
      onClick();
    } else if ("/dashboard") {
      navigate("/dashboard"); // navigate to a specific route
    } else {
      navigate(-1); // fallback
    }
  };
  return (
    <CardWrapper>
      <Box className="ContentWrapper">
        <Typography component="h2">Kanban Board</Typography>
        <BackButton onClick={handleBackClick} sx={{ "& button": { marginBottom: "0 !important" } }} />
      </Box>
      <Box className="FilterChipWrapper">
        {getPriorityFilteredFlags(selectedFlags, selectedPriority)?.map((flag, idx) => (
          <Chip
            key={idx}
            label={flag}
            onDelete={
              selectedFlags.length > 1
                ? () => {
                    const updatedFlags = selectedFlags.filter(f => f !== flag);
                    const params = new URLSearchParams(searchParams);
                    if (updatedFlags.length) params.set("flags", updatedFlags.join(","));
                    else params.delete("flags");
                    setSearchParams(params);
                  }
                : undefined
            }
            variant="filled"
            deleteIcon={<HighlightOffOutlinedIcon />}
          />
        ))}
      </Box>
    </CardWrapper>
  );
}

export default KanbanBoardHeader;
